import styled from 'styled-components'

export const FormCheckboxWrapper = styled.div`
    position: relative;

    > label {
        align-items: flex-start;
    }

    .form__checkbox--error {
        color: #e51a45;
    }

    .checkbox-error-message {
        color: #e51a45;
        font-size: 0.75rem;
        position: absolute;
        left: 2rem;
        margin-top: 0.225rem;
        z-index: 1;
    }
`
